import { fileTypes } from "../data/components";

export const CHAT_CONSTANTS = {
  Typing_Interval: 1500, // typing indicator will update after 1.5 sec
  Trim_Reply_Length: 50, // replied msg trim length
  AUTO_DECLINE_CALL: 30000, // call will be declined after 30 sec
  GROUP_MSG_AFTER: 1, // message grouping in chat area
  MESSAGE_MAX_LENGTH: 20000, // allowed per text message length
  MARK_USER_AWAY: 600000, // after 10 min current user status will become away
  USER_STATUS_HEARTBEAT: 60000,
  FILE_TYPE_ALLOWANCE: Object.values(fileTypes)
    .map((t) => t.extensions)
    .join(','),
}
